"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var asg_1 = require("@alinta-digital/asg");
var Styles_1 = require("./Styles");
var CreditCardField = function (_a) {
    var focus = _a.focus, label = _a.label, elementId = _a.elementId, error = _a.error, errorMessage = _a.errorMessage, icon = _a.icon, maxWidth = _a.maxWidth;
    return (react_1.default.createElement(Styles_1.StyledInputContainer, { maxWidth: maxWidth },
        react_1.default.createElement(Styles_1.StyledInputWrapper, null,
            react_1.default.createElement(asg_1.FormLabel, { htmlFor: elementId, color: asg_1.colors['colour-black'], style: { fontWeight: '500' } },
                react_1.default.createElement(asg_1.Box, { direction: "row", width: "100%", margin: { bottom: '5px' } },
                    react_1.default.createElement(asg_1.Box, { align: "start", "data-testid": "ccLabel", margin: { right: '11px' } }, label),
                    icon && react_1.default.createElement(asg_1.Box, { "data-testid": "icon" }, icon))),
            react_1.default.createElement(Styles_1.StyledDiv, { id: elementId, "data-testid": "ccElementId", tabIndex: 1, focus: focus ? focus : false, error: error })),
        error && (react_1.default.createElement(Styles_1.StyledMaskedError, { id: elementId && "error-" + elementId, "data-testid": "errorMsg" }, errorMessage))));
};
exports.default = CreditCardField;
//# sourceMappingURL=CreditCardField.js.map